export default "__VITE_ASSET__bezluP8D__"